import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconChromecastFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconChromecastFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5fb5068f6f5550065e96e17d96a7c6476095b556', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'c96302a4bf98a7fa6ac0ae5197c7d6629ab18b16', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '72b4bc4592eaf7338d570eaa471e8bad4f79c81b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.5 4h-17a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h16v11h-4.8a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5.8a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5M4.62 17.4a2.83 2.83 0 0 0-2-2 .5.5 0 0 0-.6.49v1.61a.51.51 0 0 0 .51.5h1.6a.49.49 0 0 0 .49-.6m-2.09-5.33c2.864.275 5.13 2.505 5.4 5.37a.49.49 0 0 1-.45.56h-.5a.52.52 0 0 1-.5-.47c-.224-2.11-1.89-3.736-4-3.96a.51.51 0 0 1-.48-.5v-.5a.5.5 0 0 1 .53-.5M2 9.81a.52.52 0 0 0 .49.5 7.7 7.7 0 0 1 7.22 7.21.49.49 0 0 0 .49.48h.5a.51.51 0 0 0 .51-.52 9.2 9.2 0 0 0-8.67-8.67.51.51 0 0 0-.54.5zm11.1 5.69C12 11 9 8 4.4 6.5h13.1v9z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-chromecast-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chromecast-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chromecast-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChromecastFilled$1);
            }
            break;
    } });
}

const CosmosIconChromecastFilled = CosmosIconChromecastFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconChromecastFilled, defineCustomElement };
